{
  "actionbar.actions": "操作",
  "actionbar.actionsAvailable": "有可用操作。",
  "actionbar.clearSelection": "清除选择",
  "actionbar.selected": "{count, plural, =0 {无选择} other {已选择 # 个}}",
  "actionbar.selectedAll": "全选",
  "breadcrumbs.more": "更多项目",
  "button.pending": "待处理",
  "calendar.invalidSelection": "选定的 {selectedCount, plural, one {个日期} other {个日期}} 不可用。",
  "combobox.noResults": "无结果",
  "contextualhelp.help": "帮助",
  "contextualhelp.info": "信息",
  "datepicker.endTime": "结束时间",
  "datepicker.startTime": "开始时间",
  "datepicker.time": "时间",
  "dialog.alert": "警报",
  "dialog.dismiss": "取消",
  "dropzone.replaceMessage": "删除要替换的文件",
  "inlinealert.informative": "信息",
  "inlinealert.negative": "错误",
  "inlinealert.notice": "警告",
  "inlinealert.positive": "成功",
  "label.(optional)": "（可选）",
  "label.(required)": "（必填）",
  "menu.moreActions": "更多操作",
  "notificationbadge.indicatorOnly": "新活动",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "选择...",
  "picker.selectedCount": "{count, plural, =0 {未选择任何项} one {已选择 # 个项} other {已选择 # 个项}}",
  "slider.maximum": "最大",
  "slider.minimum": "最小",
  "table.cancel": "取消",
  "table.editCell": "编辑单元格",
  "table.loading": "正在加载...",
  "table.loadingMore": "正在加载更多...",
  "table.resizeColumn": "调整列大小",
  "table.save": "保存",
  "table.sortAscending": "升序排序",
  "table.sortDescending": "降序排序",
  "tag.actions": "操作",
  "tag.hideButtonLabel": "显示更少",
  "tag.noTags": "无",
  "tag.showAllButtonLabel": "全部显示 ({tagCount, number})",
  "toast.clearAll": "全部清除",
  "toast.collapse": "折叠",
  "toast.showAll": "显示全部"
}
